/**
 * Observations Service
 * Observations management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ComponentObservationDto } from './componentObservationDto';
import { ComponentObservationDtoValueData } from './componentObservationDtoValueData';
import { ObservationTypeResponseDto } from './observationTypeResponseDto';


export interface ObservationResponseDto { 
    /**
     * Observation identifier
     */
    id: string;
    /**
     * Tenant identifier
     */
    tenantId: string;
    /**
     * Patient identifier
     */
    patientId: string;
    /**
     * Element identifier
     */
    elementId: string;
    /**
     * Metadata schema from element
     */
    metadataSchema: any;
    status: ObservationResponseDto.StatusEnum;
    effectiveDateTime: string;
    issuedDateTime: string;
    /**
     * Type of the observation value
     */
    valueType?: ObservationResponseDto.ValueTypeEnum;
    valueData?: ComponentObservationDtoValueData;
    components: Array<ComponentObservationDto>;
    interpretation?: string;
    /**
     * Reference range for the observation
     */
    referenceRange?: string;
    note?: string;
    createdOn: string;
    updatedOn: string;
    createdBy?: string;
    updatedBy?: string;
    /**
     * Expanded observation type data from reference-data-service
     */
    observationType?: ObservationTypeResponseDto;
}
export namespace ObservationResponseDto {
    export type StatusEnum = 'open' | 'closed' | 'on-hold';
    export const StatusEnum = {
        Open: 'open' as StatusEnum,
        Closed: 'closed' as StatusEnum,
        OnHold: 'on-hold' as StatusEnum
    };
    export type ValueTypeEnum = 'quantity' | 'string' | 'boolean' | 'integer' | 'time' | 'dateTime' | 'period' | 'range' | 'ratio';
    export const ValueTypeEnum = {
        Quantity: 'quantity' as ValueTypeEnum,
        String: 'string' as ValueTypeEnum,
        Boolean: 'boolean' as ValueTypeEnum,
        Integer: 'integer' as ValueTypeEnum,
        Time: 'time' as ValueTypeEnum,
        DateTime: 'dateTime' as ValueTypeEnum,
        Period: 'period' as ValueTypeEnum,
        Range: 'range' as ValueTypeEnum,
        Ratio: 'ratio' as ValueTypeEnum
    };
}


